import { useState } from "react";
import Button from "shared/Button";
import { setRoleVerdict } from "../api/CrmApi";

/** Mark a company whose role the sheet did not say as prime or sub on ONE RFP. "Sub" unlinks it from that RFP; the company stays. */
export default function RoleVerdictButtons({
  opportunityId, companyId, companyName, onDecided,
}: { opportunityId: number; companyId: number; companyName: string; onDecided: () => void }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function decide(verdict: "prime" | "sub") {
    if (verdict === "sub" && !window.confirm(`Mark ${companyName} as a sub-contractor on this RFP?\n\nIt is taken off this RFP's list and will not be emailed for it. The company stays in the CRM.`)) return;
    setBusy(true);
    setError(null);
    try {
      await setRoleVerdict(opportunityId, companyId, verdict);
      onDecided();
    } catch (e: any) {
      setError(e?.response?.data?.detail || "Could not save the role");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mt-1 flex flex-col gap-1">
      <div className="flex gap-1.5">
        <Button variant="brand-outline" size="sm" disabled={busy} onClick={() => decide("prime")} title="This company can lead the bid on this RFP: it stays on the list and goes on through the normal checks">
          Mark prime
        </Button>
        <Button variant="outline" size="sm" disabled={busy} onClick={() => decide("sub")} title="This company would only be a sub-contractor on this RFP: it is taken off this RFP's list">
          Mark sub
        </Button>
      </div>
      {error && <span className="text-xs text-destructive" role="alert">{error}</span>}
    </div>
  );
}
